export const showMenu = {
  data () {
    return {
      menu: false
    }
  },
  methods: {
    showMenu () {
      this.menu = !this.menu
      this.menu ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    }
  }
}

export const closeMenu = {
  methods: {
    $_closeMenu () {
      this.$store.dispatch('VIEW_MENU', false)
      document.body.classList.remove('body-stop')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins.js